var exports = {
  "k": "xa15a2ab7--4e33e0--container",
  "n": "xa15a2ab7--4e33e0--link",
};

module.exports = exports;
